import { postRequest } from "./apiService";

/**
 * Uploads a file to a signed URL using a PUT request.
 *
 * @param {File|Blob} file - The file to be uploaded.
 * @param {string} signedUrl - The pre-signed URL provided for uploading the file.
 * @param {string} contentType - The MIME type of the file being uploaded.
 * @returns {Promise<void>} - Logs success or failure of the upload.
 *
 * This function sends the file as a binary stream using the `fetch` API.
 * The `Content-Type` header is set to `application/octet-stream` to ensure proper handling by the server.
 */
async function uploadWithSignedUrl(file, signedUrl, contentType) {
  try {
    const response = await fetch(signedUrl, {
      method: "PUT",
      headers: { "Content-Type": "application/octet-stream" },
      body: file,
    });
    if (response.ok) {
      console.log("Upload successful");
      return response.url;
    } else {
      console.error("Upload failed");
    }
  } catch (error) {
    console.error("Upload error:", error);
  }
}

/**
 * Function to generate a signed URL for uploading a file.
 * @param {object} formData - The form data.
 */

export const generateSignedUrl = async (formData) => {
  const url = `https://insureai-intake-dev-1074099157700.us-central1.run.app/insureai/ml/v1/no_support/signed-url`;
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const result = await postRequest(
    url,
    {
      customer_name: formData.customer_name,
      email: formData.email,
      fileName: formData.attachment.name,
    },
    headers
  );

  const uploadDocURL = await uploadWithSignedUrl(
    formData.attachment,
    JSON.parse(result[0]).signed_url,
    formData.attachment.type
  );

  const supportFormData = { ...formData };
  supportFormData.attach_link = uploadDocURL;
  delete supportFormData.attachment;

  await submitSupportForm(supportFormData);
};

/**
 * Submits the support form data to the API endpoint.
 *
 * @param {Object} formData - The support form data containing user input fields.
 * @returns {Promise<any>} - The API response.
 *
 * This function makes a POST request to submit the support form data.
 * It sends the data as JSON with appropriate headers and returns the response from the API.
 */
export const submitSupportForm = async (formData) => {
  const url =
    "https://insureai-intake-dev-1074099157700.us-central1.run.app/insureai/ml/v1/no_support/support-form";
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  const result = await postRequest(url, JSON.stringify(formData), headers);
  return result;
};
